module.exports = __webpack_public_path__ + "static/media/MOSFET Board 2 6-min.793b6e69.jpg";